import { EnvelopeIcon } from "@heroicons/react/24/outline";
import React from "react";
import { mailtoUri } from "util/uri";
import {
    ContactValueRow,
    contactValueLinkClasses,
    stopClickPropagation,
} from "./display-row";

interface GuestEmailDisplayProps {
    value: string;
}

export const GuestEmailDisplay: React.FC<GuestEmailDisplayProps> = props => {
    const { value } = props;

    if (!value) {
        return null;
    }

    return (
        <ContactValueRow Icon={EnvelopeIcon}>
            <a
                href={mailtoUri(value)}
                title={`Email ${value}`}
                onClick={stopClickPropagation}
                className={contactValueLinkClasses}>
                {value}
            </a>
        </ContactValueRow>
    );
};
